var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FormController {
    constructor(form) {
        this.form = form;
        this.formData = {};
        this.changedInputFields = [];
        this.form.form_fields.map((field) => {
            this.formData[field.fieldname] = field.default ? field.default : "";
        });
    }
    onChange(e) {
        this.formData[e.target.id] = e.target.value.trim();
        if (!this.changedInputFields.includes(e.target)) {
            this.changedInputFields.push(e.target);
        }
    }
    getDocName() {
        return this.form.title;
    }
    getFormFields() {
        return this.form.form_fields;
    }
    submitData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.form.name) {
                return;
            }
            let headers = Object.assign({
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Access-Control-Allow-Origin': '*',
            });
            let path = '/api/create_doc';
            let requestBody = JSON.stringify({
                form_id: this.form.name,
                doc_type: this.form.doc_type,
                values: this.formData
            });
            // Fetching data
            const res = yield fetch(path, {
                method: 'POST',
                headers,
                body: requestBody,
            });
            const response = yield res.json();
            if (response.message.form_status == 'success') {
                if (this.form.success_url && this.form.success_url != '') {
                    const page_data = {
                        doctype: this.form.doc_type,
                        document_id: this.form.name
                    };
                    let url = this.form.success_url + '#' + btoa(JSON.stringify(page_data));
                    window.location.href = url;
                }
                else {
                    let message = this.form.success_message ? this.form.success_message : 'Success';
                    this.setFormMessage(message, false);
                }
            }
            else {
                let message = response.message.form_error_message;
                this.setFormMessage(message, true);
            }
        });
    }
    setFormMessage(message, isError) {
        let form_element = document.getElementById(this.form.name);
        if (form_element) {
            let form_status_elements = form_element.getElementsByClassName('form-status');
            for (let i = 0; i < form_status_elements.length; i++) {
                let form_status = form_status_elements[i];
                if (form_status instanceof HTMLElement) {
                    form_status.style.display = 'block';
                    form_status.className = isError ? 'form-status form-error' : 'form-status form-success';
                    form_status.innerHTML = message;
                }
                else {
                    console.log("Form status not found");
                }
            }
        }
        else {
            console.log("Form not found: " + this.form.name);
        }
    }
    cleanForm() {
        this.cleanFormElement();
        this.cleanFormMessages();
    }
    cleanFormMessages() {
        let form_element = document.getElementById(this.form.name);
        if (form_element) {
            let form_status_elements = form_element.getElementsByClassName('form-status');
            for (let i = 0; i < form_status_elements.length; i++) {
                let form_status = form_status_elements[i];
                if (form_status instanceof HTMLElement) {
                    form_status.style.display = 'none';
                    form_status.className = 'form-status';
                    form_status.innerHTML = '';
                }
                else {
                    console.log("Form status not found");
                }
            }
        }
        else {
            console.log("Form not found: " + this.form.name);
        }
    }
    cleanFormElement() {
        for (let i = 0; i < this.changedInputFields.length; i++) {
            this.changedInputFields[i].value = '';
        }
    }
}
//# sourceMappingURL=FormController.js.map